export default __webpack_public_path__ + "static/media/mobile.b12ff5cd.png";